import { createElement } from 'react';
import { LinkItemProps } from '.';
import { Link } from '../../Link';
import { Text } from '../../Text';
import { useBidiFormatter } from '../../../locale/useBidiFormatter';
import { postfixTestId } from '../../../util/testId';
import { Flow } from '../../Layouts/Flow';
import { isNullish } from '@sas/nova-core/typeguards';
import { Icon } from '../../Icon';

import cx from 'classnames';
import './LinkItem.css';
import cn from './LinkItem.css.json';
/**
 * The LinkItem component that renders the Link element.
 *
 * <b>Note:</b> The LinkItem is meant to use either a ListProps'
 * `renderItem` or ListColumnProps' `item`, which will display
 * at the body of the item.
 *
 * @component
 * @param {LinkItemProps} props the LinkItemProps properties
 * @returns the LinkItem element
 */
export const LinkItem = (props: LinkItemProps) =>
  props.icon ? (
    <Flow spacing="s" className={cn.contentContainer}>
      {ItemIcon(props)}
      {Content(props)}
    </Flow>
  ) : (
    Content(props)
  );

const Content = (props: LinkItemProps) => {
  const { readOnly, onPress, testId, children } = props;
  const bidiFormatter = useBidiFormatter();

  return readOnly ? (
    <Text className={props.className} style={props.style} wrapText={false}>
      {typeof children === 'string' ? bidiFormatter(children) : ''}
    </Text>
  ) : (
    <div
      className={cn.linkWrapper}
      onClick={(e) => {
        if (onPress) e.stopPropagation();
      }}
    >
      <Link {...props} wrapText={false} testId={postfixTestId(testId, 'link')} />
    </div>
  );
};

const ItemIcon = (props: LinkItemProps) =>
  isNullish(props.icon) ? null : (
    <Icon
      {...props.icon}
      className={cx(cn.itemIcon, props.icon.className)}
      disabled={props.disabled}
    />
  );
